import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import ADHDUserCourse from './ADHDUserCourse'



export default function CourseCard() {
    const navigate = useNavigate();


    const [course, setCourse] = useState({
      title: "ADHD Nursing Proficiency Course",
      subtitle: "Professional Development Program for Mental Health Practice",
      duration: "Allow approximately 4 hours (self-paced)",
      certification: "ADHD Nursing Proficiency Certificate",
      passRequirement:
        "100% on all module assessments – 10 questions each module",
      instruction:
        "You can complete the Course at your own pace in your own time. There are no time limits on any module. You can stop and resume at any time. You must answer all 10 questions correctly at the end of each module before you can proceed to the next module.",
      overview:
        "Welcome to the ADHD Nursing Proficiency Course - your pathway to becoming an ADHD care expert. This comprehensive training transforms registered nurses into confident, competent ADHD specialists through eight structured modules covering everything from neurobiology to crisis management.",
      whatYouWillMaster: [
        "ADHD neurobiology and symptom recognition",
        "Medication management and monitoring protocols",
        "Patient assessment techniques including telehealth",
        "Side effect management and crisis intervention",
        "Complex case management with comorbidities",
        "Professional communication and documentation",
        "Quality improvement and career advancement",
      ],
      modules: [
        {
          number: 1,
          title: "ADHD Fundamentals & Neurobiology",
          alias: "Foundations",
          duration: "Allow 30 min",
        },
        {
          number: 2,
          title: "ADHD Medications & Pharmacology",
          alias: "Medications",
          duration: "Allow 30 min",
        },
        {
          number: 3,
          title: "Patient Assessment & Telehealth Monitoring",
          alias: "Assessment",
          duration: "Allow 30 min",
        },
        {
          number: 4,
          title: "Managing Side Effects & Crisis Intervention",
          alias: "Side Effects",
          duration: "Allow 30 min",
        },
        {
          number: 5,
          title: "Comorbid Conditions & Complex Cases",
          alias: "Complex Cases",
          duration: "Allow 30 min",
        },
        {
          number: 6,
          title: "Communication & Crisis Management",
          alias: "Communication",
          duration: "Allow 25 min",
        },
        {
          number: 7,
          title: "Documentation & Legal Considerations",
          alias: "Documentation",
          duration: "Allow 25 min",
        },
        {
          number: 8,
          title: "Professional Excellence & Career Development",
          alias: "Professional Excellence",
          duration: "Allow 20 min",
        },
      ],
    });



    const handleStartCourse = () => {
        navigate(`/nurse/mycourse`);
    };
    

  return (
    <>
    <div className="px-3 py-8">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
        {/* Header with Start Course Button */}
        <div className="bg-white px-6 py-4 flex items-center border-b border-gray-200">
          <div className="text-black">
            <h1 className="text-xl font-bold">{course.title}</h1>
            <p className="text-gray-600 text-sm">{course.subtitle}</p>
          </div>
        </div>

        {/* Card Content */}
        <div className="p-6">
          {/* Course Details */}
          <div className="mb-6 space-y-1">
            <p><strong>Course Duration:</strong> {course.duration}</p>
            <p><strong>Certification:</strong> {course.certification}</p>
            <p><strong>Pass Requirement:</strong> {course.passRequirement}</p>
          </div>

          {/* Instruction */}
          <div className="mb-6">
            <h2 className="text-lg font-bold mb-2">Instruction:</h2>
            <p className="leading-relaxed">
              {course.instruction}
            </p>
          </div>

          {/* Course Overview */}
          <div className="mb-6">
            <h2 className="text-lg font-bold mb-2">Course Overview</h2>
            <p className="leading-relaxed">
              {course.overview}
            </p>
          </div>

          {/* What You'll Master */}
          <div className="mb-6">
            <h2 className="text-lg font-bold mb-2">What You'll Master:</h2>
            <ul className="space-y-1">
              {course.whatYouWillMaster.map((item, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Learning Path */}
          <div className="mb-6">
            <h2 className="text-lg font-bold mb-3">Learning Path:</h2>
            <div className="overflow-x-auto">
              <table className="w-full border border-gray-200 rounded-lg">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700 border-b border-gray-200">
                      Module
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700 border-b border-gray-200">
                      Title
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700 border-b border-gray-200">
                      Alias
                    </th>                
                  </tr>
                </thead>
                <tbody>
                  {course.modules.map((m) => (
                    <tr key={m.number} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">
                        {m.number}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">
                        {m.title}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">
                        {m.alias}
                      </td>
                     
                    </tr>
                  ))}
                </tbody>
              </table>
                <div
                  className="flex items-center p-4 mt-2 text-sm rounded-lg bg-green-50 text-green-800 dark:bg-gray-800 dark:text-green-300"
                  role="alert"
                >
                  {/* Icon */}
                  <svg
                    className="flex-shrink-0 inline w-5 h-5 mr-2 text-green-600 dark:text-green-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  {/* Text */}
                  <span className="font-semibold">Certification:</span>
                  <span className="ml-1">
                    Personalised Certificate{" "}
                    <span className="italic">(Acknowledgement of Completion)</span>
                  </span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ADHDUserCourse />
    </>
  );
}
